import React from "react";

const TableHeader = (props) => {
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          boxSizing: "border-box",
          padding: "1em",
        }}
      >
        {props.columns.map((item) => (
          <div
            style={{
              padding: ".8em",
              paddingBottom: "0.6em",
              borderBottom:
                props.activeTab == item.id ? "2px solid #6f42c1" : "none",
              cursor: "pointer",
              fontWeight: "bold",
            }}
            onClick={() => props.handleTabChange(item.id)}
          >
            {item.value}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableHeader;
